import { ReactNode } from "react";
import styles from "./CallOut.module.scss"

interface CallOutProps
{
    children : ReactNode
}
export default function CallOut(props: CallOutProps)
{
return(

    <div className = {styles.callOut}>
    {props.children}
    </div>
);
}